import React, {
    useCallback, useContext, useMemo, useState
} from 'react';
import _ from 'lodash';
import moment from 'moment';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import {
    Button, CheckboxField, Tab, TabSet
} from '@jutro/components';
import { CepConstants } from 'saga-cep-specific-components';
import { SgNumberUtil } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import messages from '../SgPolicyPaymentTile.messages';
import cepMessages from '../../cep.messages';

function SgPaymentTileInvoicesDetails(props) {
    const {
        id,
        paymentDetails,
        toPayFilterSelected,
        setToPayFilterSelected,
        paidFilterSelected,
        setPaidFilterSelected,
        setShowPaymentInstrument,
        invoiceStreams
    } = props;

    const intl = useContext(IntlContext);
    const translator = useContext(TranslatorContext);
    const [selectedInvoiceStream, setSelectedInvoiceStream] = useState(invoiceStreams[0]);

    const invoiceSummary = useMemo(() => {
        if (_.isNil(paymentDetails)) return null;
        return (
            paymentDetails.invoiceSummary
                .filter((item) => {
                    const paid = item.paidStatus === CepConstants.PAID_STATUS.FULLY_PAID || item.totalPaid.amount !== 0;
                    const unpaid = item.paidStatus === CepConstants.PAID_STATUS.UNPAID;
                    return (paid && paidFilterSelected) || (unpaid && toPayFilterSelected);
                })
                .map((invoice, index) => {
                    const invoiceDetailKey = `invoiceDetail_${index}`;
                    if (selectedInvoiceStream.pperiodId_Ext === invoice.pperiodId_Ext) {
                        return (
                            <tr key={invoiceDetailKey}>
                                <td>
                                    {!_.isNil(invoice.lastPaymentDate) && invoice.amountDue.amount === 0
                                        ? moment(invoice.lastPaymentDate).format('DD/MM/yyyy')
                                        : moment(invoice.dueDate).format('DD/MM/yyyy')}
                                </td>
                                <td>{SgNumberUtil.getCurrencyValue(intl, invoice.totalValue)}</td>
                                <td>
                                    {invoice.paidStatus === CepConstants.PAID_STATUS.FULLY_PAID ? translator(cepMessages[invoice.paidStatus])
                                        : translator(cepMessages[invoice.invoiceStatus])}
                                </td>
                            </tr>
                        );
                    }
                    return <></>;
                })
        );
    }, [intl, paidFilterSelected, paymentDetails, selectedInvoiceStream, toPayFilterSelected, translator]);

    const getTabName = useCallback((invoice) => {
        return invoice.termNumber === _.minBy(invoiceStreams, 'termNumber').termNumber
            ? translator(messages.CurrentPolicy) : translator(messages.Renewal);
    }, [translator, invoiceStreams]);

    const selectInvoiceTab = useCallback((tab) => {
        // eslint-disable-next-line
        const invoiceIndex = parseInt(tab.split('-')[1]);
        setSelectedInvoiceStream(invoiceStreams[invoiceIndex]);
    }, []);

    if (_.isNil(paymentDetails)) return null;

    return (
        <div>
            { invoiceStreams.length > 1
                && (
                    <div className="sgCepPaymentTabsetContainer">
                        <TabSet
                            id="tabsForSelectedPolicy"
                            defaultActiveTab="invoiceTab-0"
                            onTabChange={(tab) => selectInvoiceTab(tab)}
                            tabOnly
                            showArrows={false}
                        >
                            { invoiceStreams.map((invoiceStream, index) => {
                                return (
                                    <Tab
                                        id={`invoiceTab-${index}`}
                                        className={invoiceStream === selectedInvoiceStream ? 'sgCepPaymentTabSelected' : 'sgCepPaymentTab'}
                                        heading={getTabName(invoiceStream)}
                                    />
                                );
                            })
                            }
                        </TabSet>
                    </div>
                )
            }
            <div id={`policyPaymentInvoices_${id}`} className="sgCepPaymentInvoicesDetailsContainer">
                <CheckboxField
                    id={`toPayFilter_${id}`}
                    value={toPayFilterSelected}
                    onValueChange={() => setToPayFilterSelected(!toPayFilterSelected)}
                    showValidationIcon={false}
                    label={translator(messages.InstalmentsToPayToggle, { amount: SgNumberUtil.getCurrencyValue(intl, paymentDetails.balance) })}
                    labelPosition="right"
                    className="sgCheckboxWithLabelRight"
                />
                <CheckboxField
                    id={`paidFilter_${id}`}
                    value={paidFilterSelected}
                    onValueChange={() => setPaidFilterSelected(!paidFilterSelected)}
                    showValidationIcon={false}
                    label={translator(messages.PaidInstalments, { amount: SgNumberUtil.getCurrencyValue(intl, paymentDetails.paidAmount) })}
                    labelPosition="right"
                    className="sgCheckboxWithLabelRight"
                />
                <table className="sgCepPaymentsTable">
                    <thead>
                        <tr>
                            <th>{translator(messages.PaymentDate)}</th>
                            <th>{translator(messages.PaymentAmount)}</th>
                            <th>{translator(messages.Status)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceSummary}
                    </tbody>
                </table>
                { paymentDetails.paymentInstrument.paymentMethod !== CommonConstants.PAYMENT_METHOD_CODES.CHEQUE
                    && (
                        <div className="sgBottomButtonsContainer sgButtonRightOnly">
                            <Button
                                id={`viewMyInstrument_${id}`}
                                onClick={() => setShowPaymentInstrument(true)}
                                className="sgButton"
                            >
                                {translator(messages.ViewMyInstrument)}
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default SgPaymentTileInvoicesDetails;
